import React from "react";
import { Route, Switch } from "react-router-dom";

import MainLayout from "../layout/index";
import PreviewLayout from "../layout/preview";
import NotFound from "../components/UI/NotFound";
import CheckYourEmail from "../components/UI/CheckYourEmail";

const BroadcastRouter = ({ match }) => {
  const renderBroadcastRoute = (routeProps) => {
    const hasPreviewQuery = new URLSearchParams(routeProps.location.search).has("previewKey");
    const LayoutComponent = hasPreviewQuery ? PreviewLayout : MainLayout;

    return <LayoutComponent {...routeProps} match={routeProps} />;
  };

  return (
    <Switch>
      <Route
        exact
        path={`${match.path}/:eventId`}
        render={renderBroadcastRoute}
      />
      <Route
        exact
        path={`${match.path}/:eventId/:confirmationId`}
        render={renderBroadcastRoute}
      />

      <Route
        exact
        path={`${match.path}/:eventId?template=clean&controlbar=no&reg=off&ispresenter=off`}
        render={renderBroadcastRoute}
      />



      <Route component={NotFound} />
    </Switch>
  );
};

export default BroadcastRouter;
